export default "__VITE_ASSET__Csl8dg2t__"